export default __webpack_public_path__ + "images/835f007e9bea5a4ff1162068380e9018.svg";